var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIco3PartCustomscripts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1657_1",
    "data-name": "Component 1657 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "programmer",
    transform: "translate(0 -54.262)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46988",
    "data-name": "Path 46988",
    d: "M6.219,61.318a.773.773,0,0,0-1.093,0l-4.9,4.9a.773.773,0,0,0,0,1.093l4.879,4.879A.773.773,0,1,0,6.2,71.1L1.866,66.764l4.354-4.353A.773.773,0,0,0,6.219,61.318Z",
    transform: "translate(1 -1.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46989",
    "data-name": "Path 46989",
    d: "M174.462,66.2l-4.88-4.879a.773.773,0,1,0-1.093,1.093l4.333,4.333L168.469,71.1a.773.773,0,0,0,1.093,1.093l4.9-4.9a.773.773,0,0,0,0-1.093Z",
    transform: "translate(-151.906 -1.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46990",
    "data-name": "Path 46990",
    d: "M80.555,59.959a.773.773,0,0,0-1.082.156l-7.418,9.911a.773.773,0,1,0,1.237.926l7.418-9.911A.773.773,0,0,0,80.555,59.959Z",
    transform: "rotate(-19 44.136 258.227)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13007",
    "data-name": "Rectangle 13007",
    width: 24,
    height: 24,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIco3PartCustomscripts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_3part_customscripts.11cee9462a793afa91625cc7205ce4bb.svg";